export default "__VITE_ASSET__CvlzN5iS__"